import { CJAtelier } from 'types/cj';
import _isEmpty from 'lodash-es/isEmpty';
import { isReferentielValuesEmpty } from '@teetsh/app/src/components/Bo/isReferentielValuesEmpty';

export function isAtelierEmpty(atelier: CJAtelier): boolean {
  return (
    (atelier.materials || []).length === 0 &&
    (atelier.attachments || []).length === 0 &&
    isReferentielValuesEmpty(atelier.bo) &&
    (atelier.linkedFichesDePrep || []).length === 0 &&
    _isEmpty(atelier.flow)
  );
}
